import { ActiveRecord } from '../lib/active_record.js';

export class ApplicationModel extends ActiveRecord {
}
